import Ajax from "Utils/ajax";
export const getToDoList = (data) => Ajax.post('hr/getToDoList',data);